import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import { FormTextInputDefault } from "../input/FormInput.js";
const useClasses = makeStyles()((theme) => ({
  multiStepFilterInput: {
    margin: theme.spacing(0, 2)
  },
  multiStepFilterInputLabel: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  multiStepFilterInputBackground: {
    background: theme.custom.palette.content.bulkActionSelectBackground,
    border: 0
  },
  multiStepFilterInputSize: {
    height: theme.spacing(3.75)
  },
  multiStepFilterInputArrow: {
    fontSize: theme.spacing(1.5)
  },
  multiStepFilterInputInner: {
    height: theme.custom.formActionButtonHeight
  }
}));
function MultiStepFilterInput({
  label,
  inputPlaceholder,
  inputValue,
  size = "medium",
  background = "default",
  inline = false,
  onClick
}) {
  const { classes, cx } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: inline ? null : classes.multiStepFilterInput }, label ? /* @__PURE__ */ React.createElement(Typography, { variant: "body1", className: classes.multiStepFilterInputLabel }, /* @__PURE__ */ React.createElement(LocalizedText, { label })) : null, /* @__PURE__ */ React.createElement(
    FormTextInputDefault,
    {
      size,
      variant: "outlined",
      InputProps: {
        className: cx(
          size === "small" && classes.multiStepFilterInputSize,
          background === "default" && classes.multiStepFilterInputBackground
        )
      },
      onChange: null,
      value: inputValue,
      placeholder: inputPlaceholder,
      onClick,
      inputClassName: classes.multiStepFilterInputInner,
      endAdornment: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.ArrowDown, color: IconColor.Secondary, className: classes.multiStepFilterInputArrow })
    }
  ));
}
export {
  MultiStepFilterInput
};
//# sourceMappingURL=MultiStepFilterInput.js.map
